import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchUsersRequest,
  fetchUsersSuccess,
  fetchUsersFailure
} from './userSlice';

// Mock API (replace with real one later)
function fetchMockUsers() {
  return new Promise((resolve) =>
    setTimeout(() => {
      resolve([
        { id: 1, name: "Dummy", email: "dummy@example.com" },
        { id: 2, name: "Saini", email: "saini@example.com" },
      ]);
    }, 1000)
  );
}

function* handleFetchUsers() {
  try {
    const data = yield call(fetchMockUsers);
    yield put(fetchUsersSuccess(data));
  } catch (error) {
    yield put(fetchUsersFailure(error.message));
  }
}

export default function* userSaga() {
  yield takeLatest(fetchUsersRequest.type, handleFetchUsers);
}
